import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[woNoTableDataTitle]',
  standalone: true,
})
export class NoTableDataTitleDirective {
  public constructor(public readonly template: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[woNoTableDataSubtitle]',
  standalone: true,
})
export class NoTableDataSubtitleDirective {
  public constructor(public readonly template: TemplateRef<unknown>) {}
}
